<template>
  <div class="exports-transferencias-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Exports de Transferencias">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="exportsTransferencias" 
              :fields="fields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fechaHora }}
            </template>
            <template v-slot:cell(fechaDesde)="data">
              {{ data.item.fechaDesde | fecha }}
            </template>
            <template v-slot:cell(fechaHasta)="data">
              {{ data.item.fechaHasta | fecha }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item 
                    @click.stop="exportar(data.item)">
                  <i class="fa fa-file-excel-o"></i>Exportar</b-dropdown-item>
                <b-dropdown-item 
                    @click.stop="exportarTransferencias(data.item)">
                  <i class="fa fa-file-excel-o"></i>Listado de Transferencias</b-dropdown-item>
                <b-dropdown-item 
                    @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Borrar Export</b-dropdown-item>
              </b-dropdown>
            </template>            
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Nuevo Export</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="exportModal" 
        title="Export de Transferencias"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-export-transferencias
        @close="closeExportTransferencias">
      </app-export-transferencias>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ExportTransferencias from './ABM.vue';
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import exportXLS from '../../mixins/export_xls_export_transferencias';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'exportsTransferencias/getField',
  mutationType: 'exportsTransferencias/updateField',
});

export default {
  name: 'ExportTransferenciasList',
  components: {
    appExportTransferencias: ExportTransferencias,
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
    exportXLS 
  ],
  data: () => {
    return {
      fields: [
        { 
          key: 'fechaRegistro',
          label: 'Fecha Emisión'
        },
        { 
          key: 'cliente',
        },
        { 
          key: 'evento',
        },
        { 
          key: 'eventoEtapa',
          label: 'Etapa'
        },
        { 
          key: 'fechaDesde',
        },
        { 
          key: 'fechaHasta',
        },
        { 
          key: 'usuario'
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
      exportTransferencias: 0
    }
  },
  computed: {
    ...mapFields([
      'exportsTransferencias',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'sortByDescending'
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = moment(filtro.fechaDesde).format('YYYY-MM-DD'),
      this.fechaHasta = moment(filtro.fechaHasta).format('YYYY-MM-DD'),
      this.sortByDescending = filtro.sortByDescending;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('exportsTransferencias/getExportsTransferencias')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregar () {
      this.$refs.exportModal.show();
    },
    closeExportTransferencias(registrado) {
      this.$refs.exportModal.hide();
      if (registrado) {
        this.getItems();
        // this.showModalConfirm('¿Desea descargar el archivo del export generado?', 
        //       this.exportarArchivo, 'Si', 
        //       null, 'No')
      }
    },
    consultar (item) {
      this.$router.push({ name: 'ExportTransferenciasDatos', 
                          params: { id: item.id }});
    },
    exportar(item) {
      this.showSpinner();
      this.$store.dispatch('exportTransferencias/getRptExportTransferencias', item.id)
        .then(() => this.exportarArchivo())
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    exportarArchivo() {
      let exportTransferencias = this.$store.getters['exportTransferencias/exportTransferenciasRpt'];

      if (exportTransferencias) {
        this.exportXLSExportTransferencias(exportTransferencias);
      } else {
        this.showErrorMsj('Se produjo un error al recuperar la información del export.');
      }
    },
    exportarTransferencias(item) {
      let transferencias = [];
      this.showSpinner();
      this.$store.dispatch('exportTransferencias/getTransferenciaByExport', item.id)
        .then(() => {
          transferencias = this.$store.getters['exportTransferencias/exportTransferenciasRpt'];

          /* Recuperamos la configuracion del evento */
          return this.$store.dispatch('eventoDatos/getDatos', item.eventoId);
        })
        .then(() => {
          let evento = this.$store.getters['eventoDatos/evento'];

          this.exportXLSExportTransferenciasList(evento, transferencias, 'listado_transferencias');
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    borrar (item) {
      this.showModalConfirm('¿Desea borrar el export seleccionado?', 
            this.borrarExport.bind(this, item.id), 'Si', null, 'No')
    },
    borrarExport(exportId) {
      this.showSpinner();
      this.$store.dispatch('exportsTransferencias/delete', exportId)
        .then(() => {
          this.showModalMsj('El export seleccionado se borró con éxito.', null, null, 'light')
          this.getItems();
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },

  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
  .exports-transferencias-list .registro table td[aria-colindex="1"] {
    width: 12%;
  }
  .exports-transferencias-list .registro table td[aria-colindex="2"] {
    width: 13%;
  }
  .exports-transferencias-list .registro table td[aria-colindex="3"] {
    width: Calc(25% - 30px);
  }
  .exports-transferencias-list .registro table td[aria-colindex="3"] {
    width: 15%;
  }
  .exports-transferencias-list .registro table td[aria-colindex="5"] {
    width: 10%;
  }
  .exports-transferencias-list .registro table td[aria-colindex="6"] {
    width: 10%;
  }
  .exports-transferencias-list .registro table td[aria-colindex="7"] {
    width: 15%;
  }
  .exports-transferencias-list .registro table td[aria-colindex="8"] {
    width: 30px;
  }

</style>
